import axios from "axios";
import {url_local} from '../url'
//import state from "../../store";
import state from '../../store/index' 


export function SubirLista(form) {
    //console.log(state.state.currentUser.access_token);
    const config = {
        headers : {
            'Content-Type' : 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: "Bearer " +state.state.currentUser.access_token
        }
    }

    return new Promise((res, rej) => {
        axios.post(`${url_local}lista`, form, config).then(response => {
            res(response.data);
        })
        .catch(err => {
            rej('error al subir el registro :'+err);
        });
    });
}

export function GetLista() {
    //console.log(state.state.currentUser.access_token);
    const config = {
        headers : {
            'Content-Type' : 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: "Bearer " +state.state.currentUser.access_token
        }
    }

    return new Promise((res, rej) => {
        axios.get(`${url_local}lista`, config).then(response => {
            res(response.data);
        })
        .catch(err => {
            rej('error al obtener el registro :'+err);
        });
    });
}

export function GetRegistro(item1, item2, item3, item4) {
    //console.log(state.state.currentUser.access_token);
    const config = {
        headers : {
            'Content-Type' : 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: "Bearer " +state.state.currentUser.access_token
        }
    }

    return new Promise((res, rej) => {
        axios.get(`${url_local}registro/${item1}/${item2}/${item3}/${item4}`, config).then(response => {
            res(response.data);
        })
        .catch(err => {
            rej('error al obtener el registro :'+err);
        });
    });
}

export function DeleteRegistro(item1) {
    //console.log(state.state.currentUser.access_token);
    const config = {
        headers : {
            'Content-Type' : 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: "Bearer " +state.state.currentUser.access_token
        }
    }

    return new Promise((res, rej) => {
        axios.delete(`${url_local}registro/${item1}`, config).then(response => {
            res(response.data);
        })
        .catch(err => {
            rej('error al eliminar el registro :'+err);
        });
    });
}

